import { FC } from "react";

import {
  AIMethods,
  EmbedderConfig,
  EmbedderProperty,
  switchableSiteTitles,
} from "../../index";
import { CollapsedFields } from "../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { FiltersSwitch } from "../../../components/Interaction/FiltersSwitch";
import { BooleanVoidFunc } from "../../../helpers/functions/types";
import { netTitleToSubtitle } from "../../../helpers/titles/netTitleToSubtitle";

type SwitchableAIFieldProps = {
  onChange: (title: AIMethods, property: EmbedderProperty) => BooleanVoidFunc;
  embedder?: EmbedderConfig;
  showSegmentation?: boolean;
  customGroupStyles?: string;
  customWrapperStyles?: string;
};
export const SwitchableAIField: FC<SwitchableAIFieldProps> = ({
  embedder,
  onChange,
  showSegmentation = true,
  customGroupStyles,
  customWrapperStyles,
}) => {
  if (!embedder) return null;
  const { aiTitle, active, useSegmentation } = embedder;
  const changeFields = onChange(aiTitle, "active");
  return (
    <CollapsedFields
      key={aiTitle}
      title={switchableSiteTitles[aiTitle]}
      subtitle={netTitleToSubtitle(aiTitle)}
      active={active}
      permissions="site:advanced_config:update"
      resetFields={() => changeFields(false)}
      activateFields={() => changeFields(true)}
      customGroupStyles={customGroupStyles}
      customWrapperStyles={customWrapperStyles}
    >
      {showSegmentation && (
        <div className="flex w-full items-center justify-between gap-2 px-4 py-2">
          <FiltersSwitch
            title="Segmentation"
            value={useSegmentation}
            onChange={onChange(aiTitle, "useSegmentation")}
            customId={`${aiTitle}Segmentation`}
          />
        </div>
      )}
    </CollapsedFields>
  );
};
